export const portfolioItems = [
  {
    id: 1,
    title: "Дайверские часы синего цвета с арабскими цифрами",
    result: "Мы предложили дайверский корпус с крутящимся безелем. Циферблат выбрали с переливающимся синим оттенком, который меняется в зависимости от освещения. Безель изначально делали монотонный, но клиент захотел с арабскими цифрами, поэтому сделали как просил клиент. Внутри установили механизм NH35 от Seiko - надёжный автоподзавод с поддержкой даты. Сапфировое стекло дополнили линзой над окошком даты. Ротор кастомизировали под общий стиль часов — теперь он виден через прозрачную заднюю крышку и стал частью дизайна.",
    price: "17 000 ₽",
    images: [
      "/images/portfolio/blue-diver-watch/1.jpg",
      "/images/portfolio/blue-diver-watch/2.jpg",
      "/images/portfolio/blue-diver-watch/3.jpg",
      "/images/portfolio/blue-diver-watch/4.jpg"
    ],
    clientWish: "Клиент захотел кастомные наручные часы в синем цвете с арабскими цифрами."
  },
  {
    id: 2,
    title: "Day-Date коричневые часы в цвете розового золота",
    result: "Для реализации данной задачи был выбран механизм Miyota 8285. Данный калибр позволяет вывести индикатор даты на верхнюю позицию, что соответствует техническому заданию. Было установлено сапфировое стекло, циферблат с прямыми стрелками и арабскими цифрами, общее исполнение было коричневое, корпус с PVD-покрытием под цвет розового золота.",
    price: "21 000 ₽",
    images: [
      "/images/portfolio/brown-day-date-rose-gold/front-no-black-rack.jpg",
      "/images/portfolio/brown-day-date-rose-gold/side-front.jpg",
      "/images/portfolio/brown-day-date-rose-gold/side.jpg",
      "/images/portfolio/brown-day-date-rose-gold/strap.jpg"
    ],
    clientWish: "К нам обратился клиент с референсом — фотографией модели Rolex Day-Date."
  },
  {
    id: 3,
    title: "Парные кастомные часы с уникальными циферблатами",
    result: "После нескольких эскизов мы утвердили два уникальных дизайна. В основе сборки — японские механизмы Seiko NH35 и NH05. Корпуса из нержавеющей стали с сапфировым стеклом и прозрачной задней крышкой. Форма напоминает знаменитый Patek Philippe Nautilus",
    price: "45 000 ₽",
    images: [
      "/images/portfolio/pair-sunset-sunrise/front.jpg",
      "/images/portfolio/pair-sunset-sunrise/back.jpg",
      "/images/portfolio/pair-sunset-sunrise/crown-side.jpg",
      "/images/portfolio/pair-sunset-sunrise/opposite-crown-side.jpg"
    ],
    clientWish: "Заказчики хотели, чтобы корпуса были абсолютно одинаковыми по форме, а вот циферблаты — строго кастомными, разными по характеру, но выполненными в единой стилистике."
  }
];